import { MetricConfig } from "@/features/Metrics/Metrics.types";
import RightSidebarButton from "@/features/Navigation/components/RightSidebarButton";
import clsx from "clsx";
import { AIMContextViewAtom } from "./AIMPanelContext";
import { useSetAtom } from "jotai";
import { EmptyStateCard } from "../components/EmptyStateCard";
import { Badge } from "@/ui";

export enum EmptyMetricMessageType {
    NO_DATA = "no-data",
    METRIC_NOT_SUPPORTED = "metric-not-supported",
    LINEAGE_NOT_SUPPORTED = "lineage-not-supported",
}

export interface EmptyMetricPanelProps {
    config: MetricConfig;
    messageType: EmptyMetricMessageType;
    panelTitle?: string;
}

const cardMessages = {
    [EmptyMetricMessageType.NO_DATA]: {
        title: "Data for this field is missing or unavailable.",
        body: "Please contact your admin or company representative for more information",
    },
    [EmptyMetricMessageType.METRIC_NOT_SUPPORTED]: {
        title: "This metric’s calculation is not supported in the current version.",
        body: "We’re still working on this, check back soon for the full experience!",
    },
    [EmptyMetricMessageType.LINEAGE_NOT_SUPPORTED]: {
        title: "The lineage view feature is not supported in the current version. ",
        body: "We’re still working on this, check back soon for the full experience!",
    },
};

export function EmptyMetricPanel({
    config,
    panelTitle,
    messageType,
}: EmptyMetricPanelProps) {
    const setAIMContextView = useSetAtom(AIMContextViewAtom);

    return (
        <div
            className={clsx(
                "px-6 pb-6",
                "custom-scrollbar absolute inset-0 flex min-h-0 flex-col overflow-hidden",
            )}
        >
            <div className="sticky my-4 flex flex-col">
                <RightSidebarButton
                    onClick={() => {
                        setAIMContextView(null);
                    }}
                />
                {messageType !== EmptyMetricMessageType.NO_DATA && (
                    <Badge
                        className={clsx(
                            "mb-4 bg-slate-50",
                            "text-inverted rounded-full normal-case",
                        )}
                    >
                        Coming soon
                    </Badge>
                )}
                <h2 className="pageheading">{panelTitle || config.label}</h2>
            </div>
            <div className="flex flex-col gap-4">
                <EmptyStateCard
                    heading={cardMessages[messageType].title}
                    body={cardMessages[messageType].body}
                />
            </div>
        </div>
    );
}
